import * as React from 'react';

export const LoginPage = React.lazy(() => import('./LoginPage'));
